
import Vue from 'vue'
import Router from 'vue-router'

const Parent = {
  template: '<router-view></router-view>'
}

import Login from './views/Login.vue'

import Dashboard from './views/Dashboard.vue'
import Settings from './views/Settings.vue'

import BookingIndex from './views/BookingIndex.vue'
import BookingCreate from './views/BookingCreate.vue'
import BookingEdit from './views/BookingEdit.vue'

import CustomerIndex from './views/CustomerIndex.vue'
import CustomerCreate from './views/CustomerCreate.vue'
import CustomerEdit from './views/CustomerEdit.vue'
import DuplicateCustomerIndex from './views/Customer/DuplicateCustomerIndex.vue'
import DuplicateCustomerDetails from './views/Customer/DuplicateCustomerDetails.vue'

import TourIndex from './views/TourIndex.vue'
import TourCreate from './views/TourCreate.vue'
import TourEdit from './views/TourEdit.vue'
import TourGroupEdit from './views/TourGroupEdit.vue'
import TourInstanceEdit from './views/TourInstanceEdit.vue'
import TourAccommodationEdit from './views/TourAccommodationEdit.vue'

import AgentIndex from './views/AgentIndex.vue'
import AgentCreate from './views/AgentCreate.vue'
import AgentEdit from './views/AgentEdit.vue'

import AffiliateIndex from './views/AffiliateIndex.vue'
import AffiliateCreate from './views/AffiliateCreate.vue'
import AffiliateEdit from './views/AffiliateEdit.vue'

import SupplierIndex from './views/SupplierIndex.vue'
import SupplierCreate from './views/SupplierCreate.vue'
import SupplierEdit from './views/SupplierEdit.vue'

import FlightIndex from './views/FlightIndex.vue'
import FlightCreate from './views/FlightCreate.vue'
import FlightEdit from './views/FlightEdit.vue'
import FlightBulkUpdate from './views/FlightBulkUpdate.vue'
import FlightTimeBulkUpdate from './views/FlightTimeBulkUpdate.vue'
import FlightSyncIndex from './views/FlightSyncIndex.vue'

import AirlineIndex from './views/AirlineIndex.vue'
import AirlineCreate from './views/AirlineCreate.vue'
import AirlineEdit from './views/AirlineEdit.vue'

import MultipleFlightCreate from './views/MultipleFlightCreate.vue'

import DiscountIndex from './views/DiscountIndex.vue'
import DiscountCreate from './views/DiscountCreate.vue'
// import TourDiscountCreate from './views/TourDiscountCreate.vue'
import DiscountEdit from './views/DiscountEdit.vue'

import ExtraIndex from './views/ExtraIndex.vue'
import ExtraCreate from './views/ExtraCreate.vue'
import ExtraEdit from './views/ExtraEdit.vue'

import AccommodationIndex from './views/AccommodationIndex.vue'
import AccommodationCreate from './views/AccommodationCreate.vue'
import AccommodationEdit from './views/AccommodationEdit.vue'
import AccommodationRoomEdit from './views/AccommodationRoomEdit.vue'

import RegionsIndex from './views/RegionsIndex.vue'
import RegionsEdit from './views/RegionsEdit.vue'

import PointsIndex from './views/PointsIndex.vue'
import BrochuresIndex from './views/BrochuresIndex.vue'

import SystemSettingIndex from './views/SystemSettingIndex.vue'
import SystemSettingCreate from './views/SystemSettingCreate.vue'
import SystemSettingEdit from './views/SystemSettingEdit.vue'

import BrochureRequestIndex from './views/BrochureRequestIndex.vue'
import BrochureRequestEdit from './views/BrochureRequestEdit.vue'

import ReportIndex from './views/ReportIndex.vue'

// import CancellationPolicies from './views/CancellationPolicies.vue'
import CancellationIndex from './views/Cancellation/CancellationIndex.vue'
import CancellationCreate from './views/Cancellation/CancellationCreate.vue'
import CancellationEdit from './views/Cancellation/CancellationEdit.vue'

// import AddPolicy from './views/AddPolicy.vue'

import ResortIndex from './views/ResortIndex.vue'
import ResortCreate from './views/ResortCreate.vue'
import ResortEdit from './views/ResortEdit.vue'

/**
 * Email template Views
 */
import EmailTemplateIndex from './views/EmailTemplate/EmailTemplateIndex.vue'
import EmailTemplateCreate from './views/EmailTemplate/EmailTemplateCreate.vue'
import EmailTemplateEdit from './views/EmailTemplate/EmailTemplateEdit.vue'
/**
 * End Email template Views
 */

/**
 * Tour Manager Views
 */
import TourManagerIndex from './views/TourManager/TourManagerIndex.vue'
import TourManagerCreate from './views/TourManager/TourManagerCreate.vue'
import TourManagerEdit from './views/TourManager/TourManagerEdit.vue'
/**
 * End Tour Manager Views
 */

/**
 * Service Type Views
 */
import ServiceTypeIndex from './views/ServiceType/ServiceTypeIndex.vue'
/**
 * End Service Type Views
 */

/**
 * Service Type Views
 */
import AdvertiseSizeIndex from './views/AdvertiseSize/AdvertiseSizeIndex.vue'
/**
 * End Service Type Views
 */

/**
 * Summaries Listing
 */
import SummariesIndex from './views/SummariesIndex.vue'
/**
 * End Summaries Listings
 */

/**
 * Admin Users CRUD
 */
import AdminUserIndex from './views/AdminUsers/AdminUserIndex.vue'
import AdminUserCreate from './views/AdminUsers/AdminUserCreate.vue'
import AdminUserEdit from './views/AdminUsers/AdminUserEdit.vue'
/**
 * End Admin Users CRUD
 */

/**
 * Exchange Rate CRUD
 */
import ExchangeIndex from './views/CurrencyExchange/ExchangeIndex.vue'
import ExchangeCreate from './views/CurrencyExchange/ExchangeCreate.vue'
import ExchangeEdit from './views/CurrencyExchange/ExchangeEdit.vue'
/**
 * End Exchange Rate CRUD
 */

/**
 * Database Backups
 */
import DatabaseBackups from './views/Backups/DatabaseBackups.vue'
/**
 * End Database Backups
 */

/**
 * Monthly Accounts Numbers Management
 */
import MonthlyAccounts from './views/MasterSettings/MonthlyAccounts.vue'
/**
 * End Monthly Accounts Numbers Management
 */

/**
 * Monthly Accounts Numbers Management
 */
import ThirdPartyAPI from './views/MasterSettings/ThirdPartyAPI.vue'
/**
 * End Monthly Accounts Numbers Management
 */
import LogEntriesPage from './views/LogEntriesPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/mailgun-logs',
      name: 'mailgun-log-entries',
      component: LogEntriesPage,
      meta: {
        breadcrumb: 'Log Entries',
        // auth: true
      }
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        // auth: true
      },
      redirect: '/bookings'
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        // auth: false
      }
    },
    {
      path: '/settings',
      component: Parent,
      meta: {
        breadcrumb: 'Settings',
        // auth: true
      },
      children: [
        {
          path: '',
          name: 'settings',
          component: Settings
        },
        {
          path: 'regions',
          component: Parent,
          meta: {
            breadcrumb: 'Regions',
            // auth: true
          },
          children: [
            {
              path: '',
              name: 'regions',
              component: RegionsIndex
            },
            {
              path: 'edit/:id',
              name: 'regions-edit',
              component: RegionsEdit,
              meta: {
                breadcrumb: 'Edit Region'
              },
            }
          ]
        },
        {
          path: 'points',
          component: Parent,
          meta: {
            breadcrumb: 'Pickup Points',
          },
          children: [
            {
              path: '',
              name: 'points-index',
              component: PointsIndex,
            },
          ]
        },
        {
          path: 'brochures',
          component: Parent,
          meta: {
            breadcrumb: 'Brochures',
          },
          children: [
            {
              path: '',
              name: 'brochures',
              component: BrochuresIndex
            }
          ]
        },
        {
          path: 'system',
          component: Parent,
          meta: {
            breadcrumb: 'System',
          },
          children: [
            {
              path: '',
              name: 'system-setting',
              component: SystemSettingIndex
            },
            {
              path: 'create',
              component: SystemSettingCreate,
              meta: {
                breadcrumb: 'Create new'
              },
            },
            {
              path: 'edit/:id',
              name: 'system-setting-edit',
              component: SystemSettingEdit,
              meta: {
                breadcrumb: 'Edit setting'
              },
            },
          ]
        },
        {
          path: 'monthly-accounts-management',
          component: Parent,
          meta: {
            breadcrumb: 'Monthly Accounts Management',
          },
          children: [
            {
              path: '',
              name: 'monthly-accounts',
              component: MonthlyAccounts
            }
          ]
        },
        {
          path: 'third-party-api',
          component: Parent,
          meta: {
            breadcrumb: 'Third Party API\s',
          },
          children: [
            {
              path: '',
              name: 'third-party-api',
              component: ThirdPartyAPI
            }
          ]
        }
      ]
    },
    {
      path: '/bookings',
      component: Parent,
      meta: {
        breadcrumb: 'Bookings',
        // auth: 'admin'
      },
      children: [
        {
          path: '',
          name: 'booking-index',
          component: BookingIndex
        },
        {
          path: 'create',
          component: BookingCreate,
          meta: {
            breadcrumb: 'Create new booking'
          },
        },
        {
          path: 'edit/:id',
          name: 'booking-edit',
          component: BookingEdit,
          meta: {
            breadcrumb: 'Edit booking'
          },
        }
      ]
    },
    {
      path: '/admin-user',
      component: Parent,
      meta: {
        breadcrumb: 'Admin'
      },
      children: [
        {
          path: '',
          name: 'admin-user-index',
          component: AdminUserIndex
        },
        {
          path: 'create',
          name: 'create-new-admin',
          component: AdminUserCreate,
          meta: {
            breadcrumb: 'Create new admin'
          },
        },
        {
          path: 'edit/:id',
          name: 'admin-edit',
          component: AdminUserEdit,
          meta: {
            breadcrumb: 'Edit Admin'
          },
        }
      ]
    },
    {
      path: '/customers',
      component: Parent,
      meta: {
        breadcrumb: 'Customers'
      },
      children: [
        {
          path: '',
          name: 'customer-index',
          component: CustomerIndex
        },
        {
          path: 'create',
          name: 'create-new-customer',
          component: CustomerCreate,
          meta: {
            breadcrumb: 'Create new customer'
          },
        },
        {
          path: 'edit/:id',
          name: 'customer-edit',
          component: CustomerEdit,
          meta: {
            breadcrumb: 'Edit customer'
          },
        },
        {
          path: 'duplicate-customers',
          name: 'duplicate-customer-index',
          component: DuplicateCustomerIndex,
          meta: {
            breadcrumb: 'Duplicate Customer Records'
          },
        },
        {
          path: 'duplicate-customer-detail/:email',
          name: 'duplicate-customer-detail',
          component: DuplicateCustomerDetails,
          meta: {
            breadcrumb: 'Duplicate Customer Detail'
          },
        },
      ]
    },
    {
      path: '/agents',
      component: Parent,
      meta: {
        breadcrumb: 'Agents'
      },
      children: [
        {
          path: '',
          name: 'agent-index',
          component: AgentIndex
        },
        {
          path: 'create',
          component: AgentCreate,
          meta: {
            breadcrumb: 'Create new agent'
          },
        },
        {
          path: 'edit/:id',
          name: 'agent-edit',
          component: AgentEdit,
          meta: {
            breadcrumb: 'Edit agent'
          },
        }
      ]
    },
    {
      path: '/tours',
      component: Parent,
      meta: {
        breadcrumb: 'Tours'
      },
      children: [
        {
          path: '',
          name: 'tour-index',
          component: TourIndex
        },
        {
          path: 'create',
          name: 'tour-create',
          component: TourCreate,
          meta: {
            breadcrumb: 'Create new tour'
          },
        },
        {
          path: 'edit/:id',
          name: 'tour-edit' ,
          component: TourEdit,
          meta: {
            breadcrumb: 'Edit tour'
          }
        },
        {
          path: 'groups/:id',
          name: 'tour-group',
          component: TourGroupEdit,
          meta: {
            breadcrumb: 'Edit tour group'
          }
        },
        {
          path: 'instances/:id',
          name: 'tour-instance',
          component: TourInstanceEdit,
          meta: {
            breadcrumb: 'Edit tour instance'
          }
        },
        {
          path: 'accommodation/:id',
          name: 'tour-accommodation',
          component: TourAccommodationEdit,
          meta: {
            breadcrumb: 'Edit tour accommodation'
          }
        }
      ]
    },
    {
      path: '/suppliers',
      component: Parent,
      meta: {
        breadcrumb: 'Suppliers'
      },
      children: [
        {
          path: '',
          name: 'supplier-index',
          component: SupplierIndex
        },
        {
          path: 'create',
          component: SupplierCreate,
          meta: {
            breadcrumb: 'Create new supplier'
          },
        },
        {
          path: 'edit/:id',
          name: 'supplier-edit',
          component: SupplierEdit,
          meta: {
            breadcrumb: 'Edit supplier'
          },
        }
      ]
    },
    {
      path: '/affiliates',
      component: Parent,
      meta: {
        breadcrumb: 'Affiliates'
      },
      children: [
        {
          path: '',
          name: 'affiliate-index',
          component: AffiliateIndex
        },
        {
          path: 'create',
          component: AffiliateCreate,
          meta: {
            breadcrumb: 'Create new affiliate'
          },
        },
        {
          path: 'edit/:id',
          name: 'affiliate-edit',
          component: AffiliateEdit,
          meta: {
            breadcrumb: 'Edit affiliate'
          },
        }
      ]
    },
    {
      path: '/summaries',
      component: Parent,
      meta: {
        breadcrumb: 'Summaries'
      },
      children: [
        {
          path: '',
          name: 'summary-index',
          component: SummariesIndex
        },
      ]
    },
    {
      path: '/discounts',
      component: Parent,
      meta: {
        breadcrumb: 'Discounts'
      },
      children: [
        {
          path: '',
          name: 'discount-index',
          component: DiscountIndex
        },
        {
          path: 'create',
          component: DiscountCreate,
          meta: {
            breadcrumb: 'Create new discount'
          },
        },
        {
          path: 'edit/:id',
          name: 'discount-edit',
          component: DiscountEdit,
          meta: {
            breadcrumb: 'Edit discount'
          },
        }
      ]
    },
    {
      path: '/extras',
      component: Parent,
      meta: {
        breadcrumb: 'Extras'
      },
      children: [
        {
          path: '',
          name: 'extra-index',
          component: ExtraIndex
        },
        {
          path: 'create',
          component: ExtraCreate,
          meta: {
            breadcrumb: 'Create new extra'
          },
        },
        {
          path: 'edit/:id',
          name: 'extra-edit',
          component: ExtraEdit,
          meta: {
            breadcrumb: 'Edit extra'
          },
        }
      ]
    },
    {
      path: '/flights',
      component: Parent,
      meta: {
        breadcrumb: 'Flights'
      },
      children: [
        {
          path: '',
          name: 'flight-index',
          component: FlightIndex
        },
        {
          path: 'create',
          component: FlightCreate,
          meta: {
            breadcrumb: 'Create new flight'
          },
        },
        {
          path: 'edit/:id',
          name: 'flight-edit',
          component: FlightEdit,
          meta: {
            breadcrumb: 'Edit flight'
          },
        },
        {
          path: 'multiple',
          name: 'multiple-flights',
          component: MultipleFlightCreate,
          meta: {
            breadcrumb: 'Add Multiple Flights'
          }
        },
        // {
        //   path: 'bulk-update',
        //   name: 'bulk-update-flights',
        //   component: FlightBulkUpdate,
        //   meta: {
        //     breadcrumb: 'Update Multiple Flights'
        //   }
        // },
        // {
        //   path: 'update-bulk-flight-times',
        //   name: 'update-bulk-flight-times',
        //   component: FlightTimeBulkUpdate,
        //   meta: {
        //     breadcrumb: 'Update Bulk Flight Times'
        //   }
        // },
        {
          path: 'flight-time-changes',
          name: 'flight-time-changes',
          component: FlightSyncIndex,
          meta: {
            breadcrumb: 'Flight Time Changes'
          }
        },
      ]
    },

    {
      path: '/airlines',
      component: Parent,
      meta: {
        breadcrumb: 'Airlines'
      },
      children: [
        {
          path: '',
          name: 'airline-index',
          component: AirlineIndex
        },
        {
          path: 'create',
          component: AirlineCreate,
          meta: {
            breadcrumb: 'Create new airline'
          },
        },
        {
          path: 'edit/:id',
          name: 'airline-edit',
          component: AirlineEdit,
          meta: {
            breadcrumb: 'Edit airline'
          },
        }
      ]
    },


    {
      path: '/accommodation',
      component: Parent,
      meta: {
        breadcrumb: 'Accommodation'
      },
      children: [
        {
          path: '',
          name: 'accommodation-index',
          component: AccommodationIndex
        },
        {
          path: 'create',
          component: AccommodationCreate,
          meta: {
            breadcrumb: 'Create new accommodation'
          },
        },
        {
          path: 'edit/:id',
          name: 'accommodation-edit',
          component: AccommodationEdit,
          meta: {
            breadcrumb: 'Edit accommodation'
          },
        },
        {
          path: 'room/edit/:id',
          name: 'accommodation-room-edit',
          component: AccommodationRoomEdit,
          meta: {
            breadcrumb: 'Edit accommodation room'
          },
        }
      ]
    },
    {
      path: '/brochure-requests',
      component: Parent,
      meta: {
        breadcrumb: 'Brochure Requests'
      },
      children: [
        {
          path: '',
          name: 'brochure-request-index',
          component: BrochureRequestIndex,
        },
        {
          path: 'edit/:id',
          name: 'brochure-request-edit',
          component: BrochureRequestEdit,
        }
      ],
    },
    {
      path: '/reports',
      name: 'reports-index',
      component: ReportIndex,
      meta: {
        breadcrumb: 'Reports'
      }
    },
    {
      path: '/cancellations',
      component: Parent,
      meta: {
        breadcrumb: 'Cancellation Policies'
      },
      children: [
        {
          path: '',
          name: 'cancellation-index',
          component: CancellationIndex
        },
        {
          path: 'cancellation-create',
          name:'create-cancellation',
          component: CancellationCreate,
          meta: {
            breadcrumb: 'Create cancellation policy'
          },
        },
        {
          path: 'edit/:id',
          name: 'cancellation-edit',
          component: CancellationEdit,
          meta: {
            breadcrumb: 'Edit cancellation policy'
          },
        }
      ]
    },
    {
      path: '/resorts',
      component: Parent,
      meta: {
        breadcrumb: 'Resorts'
      },
      children: [
        {
          path: '',
          name: 'resort-index',
          component: ResortIndex
        },
        {
          path: 'create',
          component: ResortCreate,
          meta: {
            breadcrumb: 'Create new resort'
          },
        },
        {
          path: 'edit/:id',
          name: 'resort-edit',
          component: ResortEdit,
          meta: {
            breadcrumb: 'Edit resort'
          },
        }
      ]
    },
    {
      path: '/templates',
      component: Parent,
      meta: {
        breadcrumb: 'Dynamic Templates'
      },
      children: [
        {
          path: '',
          name: 'email-template',
          component: EmailTemplateIndex
        },
        {
          path: 'create',
          name: 'create-email-template',
          component: EmailTemplateCreate,
          meta: {
            breadcrumb: 'Create new template'
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-template',
          component: EmailTemplateEdit,
          meta: {
            breadcrumb: 'Edit Template'
          },
        }
      ]
    },
    {
      path: '/service-types',
      component: Parent,
      meta: {
        breadcrumb: 'Service types'
      },
      children: [
        {
          path: '',
          name: 'service-types',
          component: ServiceTypeIndex
        },
      ]
    },
    {
      path: '/advertise-sizes',
      component: Parent,
      meta: {
        breadcrumb: 'Advertise Sizes'
      },
      children: [
        {
          path: '',
          name: 'advertise-sizes',
          component: AdvertiseSizeIndex
        },
      ]
    },
    {
      path: '/tour-manager',
      component: Parent,
      meta: {
        breadcrumb: 'Tour Manager'
      },
      children: [
        {
          path: '',
          name: 'tour-manager',
          component: TourManagerIndex
        },
        {
          path: 'create',
          name: 'create-tour-manager',
          component: TourManagerCreate,
          meta: {
            breadcrumb: 'Create new tour manager'
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-tour-manager',
          component: TourManagerEdit,
          meta: {
            breadcrumb: 'Edit Tour Manager'
          },
        }
      ]
    },
    {
      path: '/currency-exchange',
      component: Parent,
      meta: {
        breadcrumb: 'Currency Exchange'
      },
      children: [
        {
          path: '',
          name: 'currency-exchange-index',
          component: ExchangeIndex
        },
        {
          path: 'create',
          name: 'create-currency-exchange',
          component: ExchangeCreate,
          meta: {
            breadcrumb: 'Create new Exchange rate'
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-currency-exchange',
          component: ExchangeEdit,
          meta: {
            breadcrumb: 'Edit Currency Excahnge rate'
          },
        }
      ]
    },
    {
      path: '/backups-managemenet',
      component: Parent,
      meta: {
        breadcrumb: 'Backup Managemenet'
      },
      children: [
        {
          path: '',
          name: 'backups-list',
          component: DatabaseBackups
        }
      ]
    },
  ]
})
